module.exports = __webpack_public_path__ + "static/media/ed88cadd.jpg";